module.exports = __webpack_public_path__ + "img/vet_thumbnail-400x300.be986cd2.jpg";